/** Returns the rows sorted by name, the order every hub list shows. */
export const byName = <T>(rows: T[], nameOf: (row: T) => string) =>
  [...rows].sort((left, right) => nameOf(left).localeCompare(nameOf(right)));

/** Returns the query key of one brand hub list. */
export function brandHubQueryKey(...parts: readonly unknown[]) {
  return ['brandHub', ...parts] as const;
}
